import React from 'react';
import cx from 'classnames';
import invoke from 'lodash.invoke';
import {ShowTooltip} from '../../components/Tooltip';
import {useInputFocus} from '../hooks';
import {noop} from '@ultradent/utilities/Functions';
import {FieldWrapper} from '../index';

export function Checkbox ( {
                               name,
                               value,
                               tooltip,
                               isFocused,
                               recede,
                               disabled,
                               disabledTooltip,
                               labelClassName,
                               inputClassName,
                               label='[no label]',
                               onBlur=noop,
                               ...props
                           } ) {
    const {fieldRef} = useInputFocus( isFocused );

    return (
        <FieldWrapper name={name} disabled={disabled} disabledTooltip={disabledTooltip}>
            {( {field, form} ) => {
                const isChecked = field.value && field.value.includes( value );
                const checkboxClasses = cx( 'checkbox',
                    {
                        'checked': isChecked,
                        'disabled': disabled,
                        'recede': recede
                    }
                );
                return (
                    <div>
                        <label className={cx( 'font-normal', {'text-grey': disabled}, labelClassName )}>
                            <span className="wrap-check mr-2 flex-none">
                                <input
                                    {...props}
                                    ref={fieldRef}
                                    type="checkbox"
                                    name={name}
                                    value={value}
                                    disabled={disabled}
                                    checked={isChecked}
                                    onBlur={onBlur}
                                    onChange={e => {
                                        let nextValue;
                                        invoke( props, 'onChange', e.target.checked, value, e );

                                        if ( !field.value ) {
                                            form.setFieldValue( name, [value] );
                                            return;
                                        }

                                        if ( isChecked ) {
                                            nextValue = field.value.filter( x => x !== value );
                                            form.setFieldValue( name, nextValue );
                                            return;
                                        }

                                        nextValue = field.value.concat( value );
                                        form.setFieldValue( name, nextValue );
                                    }}
                                />
                                <span className={cx( inputClassName, checkboxClasses )}></span>
                            </span>
                            {label}
                        </label>
                        <ShowTooltip useIcon tooltip={!disabled && tooltip}/>
                    </div>
                );
            }}
        </FieldWrapper>
    );
}
